import { TransferTranslations } from "./transferTranslations.types";

const transferUkTranslations: TransferTranslations = {
    "transferPage": {
        "title": "Transfer",
    },
    "bus": {
        title: 'Bus',
        estimatedTransferTime: 'Estimated transfer time:',
        note: 'May require bus changes en route or walking to your stay.',
        description: 'A shared shuttle with fixed times and multiple stops. Bus changes or walking may be needed.'
    },
    "taxi": {
        title: 'Taxi',
        estimatedTransferTime: 'Estimated transfer time:',
        note: 'Door-to-door service',
        description: 'Private transfer with a dedicated driver for your exclusive use.'
    },
    "funicular": {
        title: 'Funicular',
        estimatedTransferTime: 'Estimated transfer time:',
        note: 'Door-to-door service',
        description: 'Reach Les Arcs easily thanks to the ultramodern funicular, which connects Bourg-Saint-Maurice station to Les Arcs 1600 station in just 7 minutes.'
    }
}

export default transferUkTranslations;